<template>
  <div id="app" class="row" > 
 
      <div v-if="!formData">
        <span>Loading</span>
        <span class="spinner-border" role="status"></span>
      </div>

      <div v-else class="col-md-6">          
        <form-viewer :formData="formData" />
      </div>

  </div>
</template>

<script lang="ts">
import { Options, Inject, Provide, Vue } from 'vue-property-decorator';
 
import { FormRepository } from '@/data/repository/FormRepository';
import { FormLayout, FormLayoutData } from '@/components/form/Forms';
import FormViewer from '@/components/form/FormViewer.vue';
 

@Options({components:{ FormViewer }})
export default class Contact extends Vue
{ 
  @Inject() formRepository!: FormRepository; 
  @Inject() formId!: string;

  public formData: any | null = null;
 

  public mounted()
  {

    if (this.formId)
    {
      this.formRepository.getForm(this.formId).then(data=>{
          this.formData=data;
      })
    }
    else {
      console.error(`Form ${this.formId} not found.` );
    }


  }
   
}
</script>

<style lang="scss">

</style>
